// mds-dojo — dojox/main. FAITHFUL port of references/dojox/main.js.
//
// Real dojo's dojox/main just `return dojo.dojox;` — an otherwise-empty namespace
// object. Apps are expected to require dojox submodules directly rather than this
// module; it only exists so the `dojox` global namespace exists for submodules to
// hang their namespaces off (e.g. dojox.gesture.tap). We publish a plain object on
// globalThis.dojox (kept identical to dojo.dojox when the dojo kernel is present)
// so the same legacy global lookups resolve.

const glob: any = globalThis as any;

const dojox: any = (glob.dojo && glob.dojo.dojox) || glob.dojox || {};

glob.dojox = dojox;
if (glob.dojo) { glob.dojo.dojox = dojox; }

export default dojox;
